export default "<perfect-scrollbar>\n    <ng-content></ng-content>\n</perfect-scrollbar>"